module.exports = __webpack_public_path__ + "static/media/day03_circlemenu.4d9bf7d6.gif";